import type * as core from '../../../../../../../core'

const pointOnClick = (typeFilter: string) => ({
  '{}': {
    action: {
      '{}': {
        payload: {
          '{}': {
            goto: {
              '{}': {
                variables: {
                  '{}': {
                    jiraStatusFilter: null,
                    typeFilter,
                    assigneeFilter: null,
                    dueDateFilter: null,
                  },
                },
                navigationId: 'requirements-dashboard',
              },
            },
          },
        },
        operation: 'ui.navigate',
      },
    },
  },
})

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Requirements by Type',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: '',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'Requirements',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Doc',
                                  y: {
                                    '??': [
                                      {
                                        '#': {
                                          '@': 'doc',
                                        },
                                      },
                                      0,
                                    ],
                                  },
                                  onClick: pointOnClick('doc'),
                                },
                              },
                              {
                                '{}': {
                                  x: 'Data',
                                  y: {
                                    '??': [
                                      {
                                        '#': {
                                          '@': 'data',
                                        },
                                      },
                                      0,
                                    ],
                                  },
                                  onClick: pointOnClick('data'),
                                },
                              },
                              {
                                '{}': {
                                  x: 'Interface',
                                  y: {
                                    '??': [
                                      {
                                        '#': {
                                          '@': 'interfaceType',
                                        },
                                      },
                                      0,
                                    ],
                                  },
                                  onClick: pointOnClick('interface'),
                                },
                              },
                              {
                                '{}': {
                                  x: 'Operational',
                                  y: {
                                    '??': [
                                      {
                                        '#': {
                                          '@': 'operational',
                                        },
                                      },
                                      0,
                                    ],
                                  },
                                  onClick: pointOnClick('operational'),
                                },
                              },
                              {
                                '{}': {
                                  x: 'Security',
                                  y: {
                                    '??': [
                                      {
                                        '#': {
                                          '@': 'security',
                                        },
                                      },
                                      0,
                                    ],
                                  },
                                  onClick: pointOnClick('security'),
                                },
                              },
                              {
                                '{}': {
                                  x: 'Functional',
                                  y: {
                                    '??': [
                                      {
                                        '#': {
                                          '@': 'functional',
                                        },
                                      },
                                      0,
                                    ],
                                  },
                                  onClick: pointOnClick('functional'),
                                },
                              },
                            ],
                          },
                        },
                      },
                    ],
                  },
                  xLabel: 'Type',
                  yLabel: 'Requirements',
                },
              },
            ],
          },
          type: 'bar',
        },
      },
    },
  },
  subqueries: {
    doc: {
      filter: {
        and: [
          {
            or: [
              { '=': [{ '@$': 'projectId' }, null] },
              {
                '=': [
                  { '@': 'specProject' },
                  { '@>': [{ '@$': 'projectId' }, 'recordId'] },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!type',
              },
              'doc',
            ],
          },
        ],
      },
      target: 'ent:!requirements:!requirement',
      selection: {
        '@.': '!id',
      },
      subqueries: {
        specProject: {
          ref: { attr: 'attr:ent#!requirements#!requirement:!spec' },
          target: 'ent:!specs:!spec',
          selection: { '@.': ['!project', { ref: { entity: '!proj' } }] },
        },
      },
    },
    data: {
      filter: {
        and: [
          {
            or: [
              { '=': [{ '@$': 'projectId' }, null] },
              {
                '=': [
                  { '@': 'specProject' },
                  { '@>': [{ '@$': 'projectId' }, 'recordId'] },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!type',
              },
              'data',
            ],
          },
        ],
      },
      target: 'ent:!requirements:!requirement',
      selection: {
        '@.': '!id',
      },
      subqueries: {
        specProject: {
          ref: { attr: 'attr:ent#!requirements#!requirement:!spec' },
          target: 'ent:!specs:!spec',
          selection: { '@.': ['!project', { ref: { entity: '!proj' } }] },
        },
      },
    },
    interfaceType: {
      filter: {
        and: [
          {
            or: [
              { '=': [{ '@$': 'projectId' }, null] },
              {
                '=': [
                  { '@': 'specProject' },
                  { '@>': [{ '@$': 'projectId' }, 'recordId'] },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!type',
              },
              'interface',
            ],
          },
        ],
      },
      target: 'ent:!requirements:!requirement',
      selection: {
        '@.': '!id',
      },
      subqueries: {
        specProject: {
          ref: { attr: 'attr:ent#!requirements#!requirement:!spec' },
          target: 'ent:!specs:!spec',
          selection: { '@.': ['!project', { ref: { entity: '!proj' } }] },
        },
      },
    },
    operational: {
      filter: {
        and: [
          {
            or: [
              { '=': [{ '@$': 'projectId' }, null] },
              {
                '=': [
                  { '@': 'specProject' },
                  { '@>': [{ '@$': 'projectId' }, 'recordId'] },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!type',
              },
              'operational',
            ],
          },
        ],
      },
      target: 'ent:!requirements:!requirement',
      selection: {
        '@.': '!id',
      },
      subqueries: {
        specProject: {
          ref: { attr: 'attr:ent#!requirements#!requirement:!spec' },
          target: 'ent:!specs:!spec',
          selection: { '@.': ['!project', { ref: { entity: '!proj' } }] },
        },
      },
    },
    security: {
      filter: {
        and: [
          {
            or: [
              { '=': [{ '@$': 'projectId' }, null] },
              {
                '=': [
                  { '@': 'specProject' },
                  { '@>': [{ '@$': 'projectId' }, 'recordId'] },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!type',
              },
              'security',
            ],
          },
        ],
      },
      target: 'ent:!requirements:!requirement',
      selection: {
        '@.': '!id',
      },
      subqueries: {
        specProject: {
          ref: { attr: 'attr:ent#!requirements#!requirement:!spec' },
          target: 'ent:!specs:!spec',
          selection: { '@.': ['!project', { ref: { entity: '!proj' } }] },
        },
      },
    },
    functional: {
      filter: {
        and: [
          {
            or: [
              { '=': [{ '@$': 'projectId' }, null] },
              {
                '=': [
                  { '@': 'specProject' },
                  { '@>': [{ '@$': 'projectId' }, 'recordId'] },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!type',
              },
              'functional',
            ],
          },
        ],
      },
      target: 'ent:!requirements:!requirement',
      selection: {
        '@.': '!id',
      },
      subqueries: {
        specProject: {
          ref: { attr: 'attr:ent#!requirements#!requirement:!spec' },
          target: 'ent:!specs:!spec',
          selection: { '@.': ['!project', { ref: { entity: '!proj' } }] },
        },
      },
    },
  },
}
